// Please do not remove this watermark
// If you wish to do so, please contact me@jackbaron.com
// The charge for this is £20 (I've gotta eat)

console.log('%cMade by Jack Baron DEV\n%cHire me! https://twitter.com/JackBaronLP', 'font-size:1.5em;color:#4558c9;', 'color:#d61a7f;font-size:1em;')



// WEBPACK FOOTER //
// ./src/js/dist/watermark.js